import { DateTime } from "luxon";
import { isBusinessDay } from "./isBusinessDay";

const SAFETY_LIMIT = 10000;

export function plusBusinessDay(date: DateTime, zone: string, businessDays: number): DateTime {
  if (!date.isValid) {
    throw new Error(`Assertion error: "date" is not valid`);
  }
  if (businessDays < 0) {
    throw new Error(`businessDays must be >= 0, but ${businessDays} given`);
  }

  // It is CRUCIAL to convert the date to given timezone.
  // Business days are with respect to stuff like day-of-the week etc, and this WILL
  // differ across timezones.
  let zonedDate = date.setZone(zone);

  let limit = SAFETY_LIMIT;

  // Seek to first non-business day
  while (!isBusinessDay(zonedDate)) {
    limit--;
    if (limit < 0) {
      throw new Error(`Probably infinite loop for ${zonedDate.toISODate()}`);
    }

    if (!zonedDate.isValid) {
      throw new Error(`Invalid date ${zonedDate}`);
    }

    zonedDate = zonedDate.plus({ days: 1 });
  }

  let businessDaysLeftToAdd = businessDays;

  // Reset limit
  limit = SAFETY_LIMIT;

  while (businessDaysLeftToAdd > 0) {
    limit--;
    if (limit < 0) {
      throw new Error(`Probably infinite loop for ${zonedDate.toISODate()}`);
    }

    if (!zonedDate.isValid) {
      throw new Error(`Invalid date ${zonedDate}`);
    }

    zonedDate = zonedDate.plus({ days: 1 });

    // USA holidays are now commented out as we use WORKDAY() google sheet function as reference
    // which does not count for holidays
    if (isBusinessDay(zonedDate) /* && !isUsaHoliday(dateTimeInGivenTimezone) */) {
      businessDaysLeftToAdd--;
    }
  }

  return zonedDate;
}
